import messages from '../locales/sv_SE.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'sv-SE',
};
export default lang;
